import React from "react";
const isLogged = JSON.parse(localStorage.getItem("user"));
export const SidebarData = [
  {
    title: "Tableau de bord",
    path: "/dashboard",
    icon: (
      <img
        width="30"
        height="50"
        style={{ marginLeft: "14px", marginRight: "10px" }}
        src={`${process.env.PUBLIC_URL}/assets/images/dashIcon.svg`}
      />
    ),
    cName: "nav-text",
    state: false,
  },
  {
    title: "Mes objets assurés",
    path: "/dashboard/contract",
    icon: (
      <img
        width="50"
        src={`${process.env.PUBLIC_URL}/assets/images/dash-1.svg`}
      />
    ),
    cName: "nav-text",
    state: false,
  },
  {
    title: "Mes Sinistres",
    path: "/dashboard/sinistre",
    icon: (
      <img
        width="50"
        src={`${process.env.PUBLIC_URL}/assets/images/dash-2.svg`}
      />
    ),
    cName: "nav-text",
    state: false,
  },
  {
    title: "Mes Remboursements",
    path: "/dashboard/Sinistre/remboursements",
    icon: (
      <img
        width="50"
        src={`${process.env.PUBLIC_URL}/assets/images/dash-3.svg`}
      />
    ),
    cName: "nav-text",
    state: false,
  },
  {
    title: "Mon Compte",
    path: "/dashboard/mon-compte",
    icon: (
      <img
        width="50"
        src={`${process.env.PUBLIC_URL}/assets/images/dash-4.svg`}
      />
    ),
    cName: "nav-text",
    state: false,
  },
  {
    title: "Contactez-Nous",
    path: "/dashboard/contactez-nous",
    icon: (
      <img
        width="50"
        src={`${process.env.PUBLIC_URL}/assets/images/dash-4.svg`}
      />
    ),
    // cName1:"nav-text1",
    cName: "nav-text",
    active: false,
  },
  {
    title: "Nos partenaires",
    path: "/dashboard/contactez-nous/assistance/nos-partenaire",
    icon: (
      <img
        width="50"
        src={`${process.env.PUBLIC_URL}/assets/images/dash-4.svg`}
      />
    ),
    cName: "nav-text",
    active: false,
  },
  {
    title: "Mentions légales",
    path: "/dashboard/mentions-legales",
    icon: (
      <img
        height="50"
        width="30"
        style={{ marginLeft: "7px", marginRight: "10px" }}
        src={`${process.env.PUBLIC_URL}/assets/images/open-book.svg`}
      />
    ),
    cName: "nav-text",
    state: false,
  },
];
// export const SidebarData = [
//   {
//     title: "Tableau de bord",
//     path: "/dashboard",
//     icon: (
//       <img
//         width="30"
//         height="50"
//         style={{ marginLeft: "14px", marginRight: "10px" }}
//         src={`${process.env.PUBLIC_URL}/assets/images/dashIcon.svg`}
//       />
//     ),
//     cName: "nav-text",
//     state: false,
//   },
//   {
//     title: "Mes objets assurés",
//     path: "/dashboard/contract",
//     icon: (
//       <img
//         width="50"
//         src={`${process.env.PUBLIC_URL}/assets/images/dash-1.svg`}
//       />
//     ),
//     cName: "nav-text",
//     state: false,
//   },
//   {
//     title: "Mes Sinistres",
//     path: "/dashboard/sinistre",
//     icon: (
//       <img
//         width="50"
//         src={`${process.env.PUBLIC_URL}/assets/images/dash-2.svg`}
//       />
//     ),
//     cName: "nav-text",
//     state: false,
//   },
//   {
//     title: "Mes Remboursements",
//     path: "/dashboard/Sinistre/remboursements",
//     icon: (
//       <img
//         width="50"
//         src={`${process.env.PUBLIC_URL}/assets/images/dash-3.svg`}
//       />
//     ),
//     cName: "nav-text",
//     state: false,
//   },
//   {
//     title: "Mon Compte",
//     path: "/dashboard/mon-compte",
//     icon: (
//       <img
//         width="50"
//         src={`${process.env.PUBLIC_URL}/assets/images/dash-4.svg`}
//       />
//     ),
//     cName: "nav-text",
//     state: false,
//   },
//   {
//     title: "Contactez-Nous",
//     path: "/dashboard/contactez-nous",
//     icon: (
//       <img
//         width="50"
//         src={`${process.env.PUBLIC_URL}/assets/images/dash-4.svg`}
//       />
//     ),
//     // cName1:"nav-text1",
//     cName: "nav-text",
//     active: false,
//   },
//   {
//     title: "Nos partenaires",
//     path: "/dashboard/contactez-nous/assistance/nos-partenaire",
//     icon: (
//       <img
//         width="50"
//         src={`${process.env.PUBLIC_URL}/assets/images/dash-4.svg`}
//       />
//     ),
//     cName: "nav-text",
//     active: false,
//   },
//   {
//     title: "Mentions légales",
//     path: "/dashboard/mentions-legales",
//     icon: (
//       <img
//         height="50"
//         width="30"
//         style={{ marginLeft: "7px", marginRight: "10px" }}
//         src={`${process.env.PUBLIC_URL}/assets/images/open-book.svg`}
//       />
//     ),
//     cName: "nav-text",
//     state: false,
//   },
// ];
